import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { fetchAttachments } from "../services/emailService";
import AttachmentList from "./AttachmentList";

export default function EmailAttachments({ emailId }) {
  const { t } = useTranslation();
  const [state, setState] = useState({ id: null, items: [], loading: true, error: false });
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    let cancelled = false;
    setState({ id: emailId, items: [], loading: true, error: false });
    fetchAttachments(emailId).then(items => {
      if (!cancelled) setState({ id: emailId, items, loading: false, error: false });
    }).catch(() => {
      if (!cancelled) setState({ id: emailId, items: [], loading: false, error: true });
    });
    return () => { cancelled = true; };
  }, [emailId, retry]);
  if (state.id !== emailId || state.loading) return <p role="status">{t("attachments.loading")}</p>;
  if (state.error) return <div role="alert">{t("attachments.loadError")} <button type="button" onClick={() => setRetry(value => value + 1)}>{t("attachments.retry")}</button></div>;
  if (!state.items.length) return <p className="attachments-empty">{t("attachments.empty")}</p>;
  return <AttachmentList attachments={state.items} />;
}
